export default function setProjectArchiveStatus({patch}: any, {id, archived}: {id: number, archived: boolean}): Promise<{}> {
  return patch(`/projects/${id}/archived`, {archived}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/projects/setProjectArchiveStatus.tsx